import React from 'react';
import { Container, Typography, Box, Paper, Divider } from '@mui/material';
// import { useTheme } from '@mui/material/styles'; // Not used

const TermsOfService: React.FC = () => {
  // const theme = useTheme(); // Not used

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom align="center">
          Terms of Service
        </Typography>
        <Typography variant="subtitle1" gutterBottom align="center" color="text.secondary">
          Last Updated: January 15, 2025
        </Typography>
        
        <Divider sx={{ my: 3 }} />

        <Box sx={{ '& h2': { mt: 4, mb: 2 }, '& h3': { mt: 3, mb: 1 }, '& p, & ul': { mb: 2 } }}>
          <Typography variant="h5" component="h2">
            1. Agreement to Terms
          </Typography>
          <Typography variant="body1" paragraph>
            By accessing or using Health-Tree ("Service"), you agree to be bound by these Terms of Service ("Terms"). If you disagree with any part of these terms, you do not have permission to access the Service.
          </Typography>

          <Typography variant="h5" component="h2">
            2. Description of Service
          </Typography>
          <Typography variant="body1" paragraph>
            Health-Tree is a gamified personal development application that provides:
          </Typography>
          <ul>
            <li>Personal development tracking through a talent tree system</li>
            <li>Goal setting and progress monitoring</li>
            <li>Analytics and insights</li>
            <li>Premium features through paid subscriptions</li>
          </ul>

          <Typography variant="h5" component="h2">
            3. User Accounts
          </Typography>
          
          <Typography variant="h6" component="h3">
            3.1 Account Creation
          </Typography>
          <ul>
            <li>You must provide accurate and complete information</li>
            <li>You must verify your email address to access the Service</li>
            <li>You are responsible for maintaining account security</li>
            <li>You must be at least 13 years old to use the Service</li>
          </ul>

          <Typography variant="h6" component="h3">
            3.2 Account Responsibilities
          </Typography>
          <ul>
            <li>You are responsible for all activities under your account</li>
            <li>You must notify us immediately of any unauthorized use</li>
            <li>We reserve the right to suspend or terminate accounts that violate these Terms</li>
          </ul>

          <Typography variant="h5" component="h2">
            4. Acceptable Use
          </Typography>
          <Typography variant="body1" paragraph>
            You agree NOT to:
          </Typography>
          <ul>
            <li>Use the Service for any illegal purposes</li>
            <li>Violate any laws in your jurisdiction</li>
            <li>Transmit any malicious code or viruses</li>
            <li>Attempt to gain unauthorized access to our systems</li>
            <li>Harass, abuse, or harm other users</li>
            <li>Create multiple accounts to abuse free features</li>
            <li>Reverse engineer or attempt to extract source code</li>
          </ul>

          <Typography variant="h5" component="h2">
            5. Premium Subscriptions
          </Typography>

          <Typography variant="h6" component="h3">
            5.1 Billing
          </Typography>
          <ul>
            <li>Premium subscriptions are billed through Stripe</li>
            <li>Subscription fees are charged in advance</li>
            <li>All fees are in USD unless otherwise specified</li>
            <li>Taxes may apply based on your location</li>
          </ul>

          <Typography variant="h6" component="h3">
            5.2 Cancellation and Refunds
          </Typography>
          <ul>
            <li>You may cancel your subscription at any time</li>
            <li>Cancellation takes effect at the end of the current billing period</li>
            <li>No refunds for partial months</li>
            <li>We reserve the right to modify pricing with 30 days notice</li>
          </ul>

          <Typography variant="h6" component="h3">
            5.3 Premium Features
          </Typography>
          <Typography variant="body1" paragraph>
            Premium subscribers receive:
          </Typography>
          <ul>
            <li>Unlimited talent points</li>
            <li>Advanced analytics</li>
            <li>Priority support</li>
            <li>Early access to new features</li>
          </ul>

          <Typography variant="h5" component="h2">
            6. Intellectual Property
          </Typography>

          <Typography variant="h6" component="h3">
            6.1 Our Property
          </Typography>
          <Typography variant="body1" paragraph>
            All content, features, and functionality of the Service are owned by us and are protected by copyright, trademark, and other intellectual property laws.
          </Typography>

          <Typography variant="h6" component="h3">
            6.2 Your Content
          </Typography>
          <ul>
            <li>You retain ownership of your personal development data</li>
            <li>You grant us a license to use your content to provide the Service</li>
            <li>We may use anonymized, aggregated data for analytics and improvements</li>
          </ul>

          <Typography variant="h5" component="h2">
            7. Privacy
          </Typography>
          <Typography variant="body1" paragraph>
            Your use of the Service is also governed by our Privacy Policy. Please review our Privacy Policy, which also governs the Service and informs users of our data collection practices.
          </Typography>

          <Typography variant="h5" component="h2">
            8. Disclaimers
          </Typography>

          <Typography variant="h6" component="h3">
            8.1 Service Availability
          </Typography>
          <ul>
            <li>The Service is provided "as is" and "as available"</li>
            <li>We do not guarantee uninterrupted or error-free service</li>
            <li>We may modify or discontinue features without notice</li>
          </ul>

          <Typography variant="h6" component="h3">
            8.2 Health and Wellness Disclaimer
          </Typography>
          <ul>
            <li>Health-Tree is not a substitute for professional medical or psychological advice</li>
            <li>Always consult qualified professionals for health-related decisions</li>
            <li>We are not responsible for any actions taken based on the Service</li>
          </ul>

          <Typography variant="h5" component="h2">
            9. Limitation of Liability
          </Typography>
          <Typography variant="body1" paragraph>
            To the maximum extent permitted by law, we shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses.
          </Typography>

          <Typography variant="h5" component="h2">
            10. Indemnification
          </Typography>
          <Typography variant="body1" paragraph>
            You agree to indemnify and hold harmless Health-Tree and its affiliates from any claims, losses, damages, liabilities, including legal fees, arising out of your use of the Service or violation of these Terms.
          </Typography>

          <Typography variant="h5" component="h2">
            11. Termination
          </Typography>

          <Typography variant="h6" component="h3">
            11.1 By You
          </Typography>
          <Typography variant="body1" paragraph>
            You may terminate your account at any time by:
          </Typography>
          <ul>
            <li>Canceling your subscription (if applicable)</li>
            <li>Requesting account deletion through the app</li>
            <li>Contacting our support team</li>
          </ul>

          <Typography variant="h6" component="h3">
            11.2 By Us
          </Typography>
          <Typography variant="body1" paragraph>
            We may terminate or suspend your account immediately, without prior notice, if:
          </Typography>
          <ul>
            <li>You breach these Terms</li>
            <li>We are required to do so by law</li>
            <li>We discontinue the Service</li>
          </ul>

          <Typography variant="h5" component="h2">
            12. Governing Law
          </Typography>
          <Typography variant="body1" paragraph>
            These Terms shall be governed by the laws of [Your Jurisdiction], without regard to its conflict of law provisions. Any disputes shall be resolved in the courts of [Your Jurisdiction].
          </Typography>

          <Typography variant="h5" component="h2">
            13. Changes to Terms
          </Typography>
          <Typography variant="body1" paragraph>
            We reserve the right to modify these Terms at any time. We will notify users of any material changes via email or through the Service. Continued use after changes constitutes acceptance of the new Terms.
          </Typography>

          <Typography variant="h5" component="h2">
            14. Severability
          </Typography>
          <Typography variant="body1" paragraph>
            If any provision of these Terms is held to be unenforceable, the remaining provisions will continue in full force and effect.
          </Typography>

          <Typography variant="h5" component="h2">
            15. Entire Agreement
          </Typography>
          <Typography variant="body1" paragraph>
            These Terms, together with our Privacy Policy, constitute the entire agreement between you and Health-Tree regarding the use of the Service.
          </Typography>

          <Typography variant="h5" component="h2">
            16. Contact Information
          </Typography>
          <Typography variant="body1" paragraph>
            For questions about these Terms, please contact us at:
          </Typography>
          <ul>
            <li>Email: legal@health-tree.com</li>
    
          </ul>

          <Typography variant="h5" component="h2">
            17. Digital Millennium Copyright Act (DMCA)
          </Typography>
          <Typography variant="body1" paragraph>
            If you believe content on our Service infringes your copyright, please contact us with:
          </Typography>
          <ul>
            <li>Description of the copyrighted work</li>
            <li>Description of the infringing material</li>
            <li>Your contact information</li>
            <li>A statement of good faith belief</li>
            <li>A statement of accuracy under penalty of perjury</li>
          </ul>

          <Typography variant="h5" component="h2">
            18. Export Compliance
          </Typography>
          <Typography variant="body1" paragraph>
            You may not use or export the Service in violation of U.S. export laws and regulations.
          </Typography>

          <Typography variant="h5" component="h2">
            19. Force Majeure
          </Typography>
          <Typography variant="body1" paragraph>
            We shall not be liable for any failure to perform our obligations due to circumstances beyond our reasonable control.
          </Typography>

          <Typography variant="body1" paragraph sx={{ mt: 4, fontStyle: 'italic' }}>
            By using Health-Tree, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service.
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default TermsOfService;